// extracted by mini-css-extract-plugin
module.exports = {"kind":"Kind_kind__Hog8N","subtype":"Kind_subtype__zebui","type":"Kind_type__6_dLN"};